import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "@studio-freight/lenis";

// Import all sections
import { Header } from "./components/layout/Header";
import { Hero } from "./components/sections/Hero";
import { FeaturedCollections } from "./components/sections/FeaturedCollections";
import { ProductCarousel } from "./components/sections/ProductCarousel";
import { BrandStory } from "./components/sections/BrandStory";
import { NewArrivals } from "./components/sections/NewArrivals";
import { CustomerExperience } from "./components/sections/CustomerExperience";
import { InstagramGallery } from "./components/sections/InstagramGallery";
import { Footer } from "./components/sections/Footer";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    // Initialize Lenis smooth scrolling
    lenisRef.current = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 2,
      infinite: false,
    });

    function raf(time) {
      lenisRef.current?.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenisRef.current?.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/*" element={
          <div className="App bg-[#FDFBF7]" data-testid="main-app">
            {/* Fixed Header */}
            <Header />

            {/* Main Content */}
            <main className="smooth-scroll">
              {/* Hero Section */}
              <Hero />

              {/* Featured Collections - Bento Grid */}
              <FeaturedCollections />

              {/* Product Carousel - Horizontal Scroll */}
              <ProductCarousel />

              {/* Brand Story - Parallax Section */}
              <BrandStory />

              {/* New Arrivals Grid */}
              <NewArrivals />

              {/* Customer Experience Benefits */}
              <CustomerExperience />

              {/* Instagram Gallery */}
              <InstagramGallery />

              {/* Footer */}
              <Footer />
            </main>
          </div>
        } />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
